module.exports = __webpack_public_path__ + "static/text-80291be73c9d84e5347bd81d708f5c24.svg";